import React, { useEffect, useState } from 'react';
import { ThemeToggle } from './components/ThemeToggle';
import { BlogPost } from './components/BlogPost';
export function App() {
  const [theme, setTheme] = useState('light');
  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);
  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };
  return <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors duration-200 scroll-smooth" data-id="element-0">
      <div className="max-w-5xl mx-auto px-4 py-4" data-id="element-1">
        <div className="flex justify-end mb-4" data-id="element-2">
          <ThemeToggle theme={theme} toggleTheme={toggleTheme} data-id="element-3" />
        </div>
        <BlogPost data-id="element-4" />
      </div>
    </div>;
}